import { Button, Grid } from "@mui/material";
import ProductoService from "../../services/ProductoService";
import AlertService from "../../services/AlertService";
import {GrDocumentPdf} from 'react-icons/gr'
import { IoDocumentAttachSharp } from "react-icons/io5";

const productoService = new ProductoService();
const alertService = new AlertService();

interface Prop{
    token: string,
    idproducto: number,
    numarchivo: number,
    tipoproducto: number,
    adjunto: string,
    idref: string,
    textoBoton:string,
}

export default function BotonArchivoAdjunto(prop:Prop){
    function linkDspace(ideref:string):string{
        if(ideref === '' || ideref === null){
          return '';
        }
        let listaArray: string[] = ideref.split(",");
        let enlace = 'http://192.168.1.125/rest/bitstreams/{ideref}/retrieve';
        enlace = enlace.replace("{ideref}", listaArray[1]);
        return enlace;
      }
    
      const abrirEnlaceEnNuevaPestana = (url:string) => {
        window.open(url, '_blank');
      };
    
      const abrirEnlaceOldInvestigacion = async (idprod:number,numarch:number) => {
        try{
            await productoService.GetRutaArchivo(idprod,numarch,prop.token)
            .then((data) => {
                //console.log(data);
                if(data.status.isSuccessfully){
                    window.open(data.data.rutaarchivo, '_blank');
                }else{
                    alertService.alertaAdvertenciaList('ATENCIÓN',data.status.messages);
                }
            })               
            .catch((error) => {
                console.error('Error:',error);
            });
        }catch(error){
            console.error('Error:',error);
        }
      };

    return (
        <>
        {prop.tipoproducto > 23 ? 
            <Button hidden={linkDspace(prop.adjunto) === ''}
            aria-label="open" 
            variant="contained"
            endIcon={<IoDocumentAttachSharp />}
            color="success" 
            onClick={() => {abrirEnlaceEnNuevaPestana(linkDspace(prop.idref))}}>
            {prop.textoBoton}
            </Button>
            :
            <Button hidden={linkDspace(prop.adjunto) === ''}
                aria-label="open" 
                variant="contained"
                endIcon={<GrDocumentPdf />}
                color="success" 
                onClick={() => {abrirEnlaceOldInvestigacion(prop.idproducto,prop.numarchivo)}}>
                {prop.textoBoton}
            </Button>
        }
        </>                   
    );
}